import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { H5 } from "@churchofjesuschrist/eden-headings";
import { blue30, spacing16, spacing8, white } from "@churchofjesuschrist/eden-style-constants";
import { Regular } from "@churchofjesuschrist/eden-light-rays";
const height = "3rem";
const Header = styled.header.withConfig({
  componentId: "sc-7msvi1-0"
})(["display:flex;justify-content:space-between;align-items:center;height:", ";background-color:", ";padding-inline-end:", ";"], height, blue30, spacing16);
const MenuButtonWrapper = styled.div.withConfig({
  componentId: "sc-7msvi1-1"
})(["background-color:", ";height:100%;display:flex;align-items:center;z-index:1;"], white);
const LightRays = styled(Regular).withConfig({
  componentId: "sc-7msvi1-2"
})(["flex:0 0 auto;", " + &{margin-inline-start:-", ";}"], MenuButtonWrapper, spacing8);
const Name = styled(H5).withConfig({
  componentId: "sc-7msvi1-3"
})(["flex:1;color:", ";margin-inline-start:", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;& > a{color:", ";text-decoration:none;&:hover{color:", ";text-decoration:underline;}}"], white, spacing16, white, white);
const Tools = styled.div.withConfig({
  componentId: "sc-7msvi1-4"
})(["display:flex;align-items:center;"]);
/** Standard header for workforce applications. */

const WorkforceHeader = _ref => {
  let {
    name,
    menuButton,
    tools,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Header, rest, menuButton ? /*#__PURE__*/React.createElement(MenuButtonWrapper, null, menuButton) : null, /*#__PURE__*/React.createElement(LightRays, {
    origin: "start",
    color: white
  }), /*#__PURE__*/React.createElement(Name, {
    renderAs: "div"
  }, name), tools ? /*#__PURE__*/React.createElement(Tools, null, tools) : null);
};

WorkforceHeader.propTypes = {
  /** The application name. Should be a single `<a>` element containing the application name. */
  name: PropTypes.node.isRequired,

  /** Must be a single `<MenuButton>` element from `eden-workforce-header`. */
  menuButton: PropTypes.element,

  /** Content to put in the tools slot. */
  tools: PropTypes.node
};
export default WorkforceHeader;